<template>
  <span
    class="material-icons"
    :class="props.color"
  >{{ name }}</span>
</template>

<script setup lang="ts">
interface IProps {
  name: string
  size?: number | string // px
  color?: string
}

const props = withDefaults(defineProps<IProps>(), {
  size: 16,
  color: 'text-inherit'
})

const iconSize = computed(() => {
  return `${props.size}px`
})
</script>
<style scoped lang="scss">
.material-icons {
  font-size: v-bind(iconSize);
}
</style>